import {hideElement, showElement} from "../visibility/showHide.js";


/**
 * Управляет видимостью и содержимым блока пользовательского соглашения.
 * При активации запрашивает данные с сервера и выводит чекбокс.
 * В случае отсутствия данных или сетевой ошибки выводит сообщение о невозможности регистрации.
 *
 * @param {boolean} [isActive=true] - Флаг состояния: true — загрузить и показать соглашение, false — очистить и скрыть
 * @param {string} [id='ttAuth_agreement_block'] - ID DOM-элемента для вставки чекбокса
 * @returns {Promise<boolean>} Успешность операции (true — соглашение загружено/скрыто, false — ошибка сервера или отсутствие блока)
 */
export async function agreementActivate(isActive = true, id = 'ttAuth_agreement_block') {
    const block = document.getElementById(id);

    if (!block) {
        console.warn(`Блок с id "${id}" не найден.`);
        return false;
    }

    if (!isActive) {
        hideElement(block);
        block.innerHTML = '';
        return true;
    }

    try {
        const data = await getAgreement();

        // Безопасная проверка: убеждаемся, что data - массив и содержит id
        if (Array.isArray(data) && data[0]?.id > 0) {
            block.innerHTML = '<label class="agreement-block"><input type="checkbox" autocomplete="off" name="agreement" value="1" required><span class="agreement-block__checkbox-text">Я прочитал и согласен с <a target="_blank" href="//tonkosti.ru/Пользовательское_соглашение">Пользовательским соглашением</a></span><span class="validity-text"></span></label>';
            showElement(block);
            return true;
        }

        // Если данные невалидны
        block.innerHTML = '<strong>В данный момент регистрация невозможна! Попробуйте позже!</strong>';
        showElement(block);
        return false;

    } catch (error) {
        console.error('Ошибка получения пользовательского соглашения:', error);
        block.innerHTML = '<strong>В данный момент регистрация невозможна! Попробуйте позже!</strong>';
        showElement(block);
        return false;
    }
}

/**
 * Запрашивает текст пользовательского соглашения с сервера в зависимости от типа пользователя.
 *
 * @param {('regular_user'|'guide')} [type='regular_user'] - Роль пользователя для формирования соглашения
 * @returns {Promise<Array|0>} Распарсенный массив с данными соглашения, либо 0 при невалидном типе
 * @throws {Error} В случае ошибки HTTP или проблем с сетью
 */
async function getAgreement(type = 'regular_user') {
    const allowedTypes = ['regular_user', 'guide'];

    if (!allowedTypes.includes(type)) {
        return 0;
    }

    const response = await fetch('/web/get-agreement-user', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json;charset=utf-8' },
        body: JSON.stringify({ type })
    });

    // Обработка HTTP-ошибок (404, 500 и т.д.), которые fetch игнорирует
    if (!response.ok) {
        throw new Error(`Ошибка HTTP: ${response.status}`);
    }

    return await response.json();
}